import React, { createContext, useContext, useEffect, useState } from 'react';

const PermissionContext = createContext();

export const PermissionProvider = ({ children }) => {
    const [permissions, setPermissions] = useState([]);

    const getPermissions = () => {
        const perms = ['survey'];

        setPermissions(perms);
    };

    useEffect(() => getPermissions(), []);

    const hasPermission = (permission) => {
        return permissions.includes(permission);
    };

    return (
        <PermissionContext.Provider value={{ permissions, setPermissions, hasPermission }}>
            {children}
        </PermissionContext.Provider>
    );
};

export const usePermissions = () => useContext(PermissionContext);
